<div class="kw-page" [nbSpinner]="isLoading">

  <button mat-button class="back-btn" type="button" (click)="back()">
    <fa-icon [icon]="faArrowLeft" class="me-2"></fa-icon>Back
  </button>

  <div class="kw-page-header">
    <div>
      <h1 class="page-title">Bulk Move</h1>
      <div class="page-subtitle">Select units to act on, or leave none selected to act on the whole list.</div>
    </div>
    <div class="header-actions">
      <button mat-stroked-button class="header-btn" type="button" (click)="scan()">
        <fa-icon [icon]="faBarcode" class="me-2"></fa-icon>Scan More
      </button>
    </div>
  </div>

  <!-- Hops: secondary lot details for the list -->
  <section class="detail-card lot-card" *ngIf="isHops" aria-labelledby="secondaryLotTitle">
    <div class="section-head">
      <fa-icon [icon]="faTag" class="section-icon"></fa-icon>
      <h3 id="secondaryLotTitle">Secondary Lot</h3>
    </div>
    <div class="lot-grid">
      <mat-form-field appearance="outline">
        <mat-label>Secondary Lot Code</mat-label>
        <input type="text" matInput [(ngModel)]="integrationId" (ngModelChange)="onSelectionChange($event)"
          [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptions" [value]="option">{{option}}</mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Date In</mat-label>
        <input matInput [matDatepicker]="dateInPicker" [(ngModel)]="dateIn">
        <mat-datepicker-toggle matIconSuffix [for]="dateInPicker"></mat-datepicker-toggle>
        <mat-datepicker #dateInPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Date Out</mat-label>
        <input matInput [matDatepicker]="dateOutPicker" [(ngModel)]="dateOut">
        <mat-datepicker-toggle matIconSuffix [for]="dateOutPicker"></mat-datepicker-toggle>
        <mat-datepicker #dateOutPicker></mat-datepicker>
      </mat-form-field>

      <button mat-stroked-button class="lot-save" type="button" (click)="onSave()">
        <fa-icon [icon]="faCheck" class="me-2"></fa-icon>Save Lot Details
      </button>
    </div>
  </section>

  <section class="detail-card units-card" aria-label="Units to move">
    <div class="toolbar">
      <div class="search-box" *ngIf="isHops">
        <fa-icon [icon]="faMagnifyingGlass" class="search-icon"></fa-icon>
        <input class="search-input" type="text" placeholder="Load by Secondary Lot Code…"
          aria-label="Load by Secondary Lot Code" [(ngModel)]="searchIntegrationId"
          (ngModelChange)="onIDSearch($event)" (keyup.enter)="searchDatabyIntegrationId()"
          [matAutocomplete]="autoSearch">
        <mat-autocomplete #autoSearch="matAutocomplete" (optionSelected)="searchDatabyIntegrationId()">
          <mat-option *ngFor="let option of filteredSearchOptions" [value]="option">{{option}}</mat-option>
        </mat-autocomplete>
      </div>

      <span class="unit-count"><b>{{session.handlingUnitBulkMoveList.length}}</b> units</span>
      <span class="count-pill">{{selectionLabel}}</span>

      <div class="toolbar-actions desktop-actions">
        <ng-container *ngTemplateOutlet="unitActions"></ng-container>
      </div>
    </div>

    <div class="grid-card">
      <ejs-grid #grid [dataSource]="this.session.handlingUnitBulkMoveList" [allowPaging]="true" [enableHover]="false"
        [selectionSettings]='selectionOptions' (checkBoxChange)="rowSelected($event)" [pageSettings]="this.pageSettings"
        [allowSorting]="true" [filterSettings]='this.filterSettings' [allowFiltering]="true"
        [enableStickyHeader]='true' height="600" [editSettings]="editSettings" (actionBegin)="actionBegin($event)"
        (actionComplete)="actionComplete($event)" (dataBound)="onDataBound()" (load)="load()">
        <e-columns>
          <e-column type='checkbox' width='60'></e-column>
          <e-column headerText="Barcode" field="tagNumber" [autoFit]="false"></e-column>
          <e-column headerText="Details" field="details" [autoFit]="false"></e-column>
          <e-column headerText="Lot" field="lot" [autoFit]="false"></e-column>
          <e-column headerText="Warehouse" field="warehouseName" [autoFit]="false"></e-column>
          <e-column headerText="Room" field="roomName" [autoFit]="false"></e-column>
          <e-column headerText="Location" field="roomLocationName" [autoFit]="true"></e-column>
          <e-column headerText="Box Start" field="boxStart" [validationRules]='boxrules' format='N' textAlign="Right" [autoFit]="true"></e-column>
          <e-column headerText="Box End" field="boxEnd" [validationRules]='boxrules' format='N' textAlign="Right" [autoFit]="true"></e-column>
        </e-columns>
        <ng-template #editSettingsTemplate let-data>
          <div ngForm #editForm="ngForm">
            <table class="e-table e-inline-edit" cellspacing="0.25">
              <colgroup>
                <col style="width: 60px;">
                <col>
                <col>
                <col>
                <col>
                <col>
                <col>
                <col>
                <col>
              </colgroup>
              <tbody>
                <tr>
                  <td></td>
                  <td>{{data.tagNumber}}</td>
                  <td>{{data.details}}</td>
                  <td>{{data.lot}}</td>
                  <td>{{data.warehouseName}}</td>
                  <td>{{data.roomName}}</td>
                  <td>{{data.roomLocationName}}</td>
                  <td style="text-align: right" class='e-rowcell'>
                    <input class="e-input e-field" [pattern]="patternReg" name="boxStart" id="boxStart"
                      (ngModelChange)="onboxStartChange($event,data)" [(ngModel)]="data.boxStart"
                      (focus)="focusIn($event)" (blur)="focusOut($event)" #boxStart="ngModel" />
                  </td>
                  <td style="text-align: right" class='e-rowcell'>
                    <input class="e-input e-field" [pattern]="patternReg" name="boxEnd" id="boxEnd" [(ngModel)]="data.boxEnd"
                      (ngModelChange)="onboxEndChange($event,data)" (focus)="focusIn($event)" (blur)="focusOut($event)"
                      #boxEnd="ngModel" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>
      </ejs-grid>
    </div>

    <!-- Phones / iPad portrait: one card per unit -->
    <div class="kw-mobile-list">
      <div class="unit-row" *ngFor="let x of session.handlingUnitBulkMoveList | slice:0:mobileVisibleCount; trackBy: trackByUnit"
        [class.selected]="isMobileSelected(x)">
        <input type="checkbox" class="unit-check" [checked]="isMobileSelected(x)" (change)="toggleMobileSelection(x)"
          [attr.aria-label]="'Select ' + x.tagNumber">
        <div class="unit-info">
          <div class="unit-code">{{x.tagNumber}}</div>
          <div class="unit-sub">{{x.details}}<ng-container *ngIf="x.lot"> · Lot {{x.lot}}</ng-container></div>
          <div class="unit-sub">{{unitLocation(x)}}</div>
        </div>
        <div class="unit-boxes" *ngIf="isHops">
          <label>Box Start
            <input class="qty-input" type="number" inputmode="numeric" [(ngModel)]="x.boxStart" (ngModelChange)="onboxStartChange($event, x)">
          </label>
          <label>Box End
            <input class="qty-input" type="number" inputmode="numeric" [(ngModel)]="x.boxEnd" (ngModelChange)="onboxEndChange($event, x)">
          </label>
        </div>
      </div>
      <button mat-stroked-button class="m-show-more" type="button"
        *ngIf="session.handlingUnitBulkMoveList.length > mobileVisibleCount" (click)="mobileVisibleCount = mobileVisibleCount + 50">
        Show more
      </button>
    </div>
  </section>

  <div class="action-bar mobile-actions">
    <ng-container *ngTemplateOutlet="unitActions"></ng-container>
  </div>

  <ng-template #unitActions>
    <printer-selector class="printer" (selectionChanged)="setPrinter($event)"></printer-selector>
    <button mat-stroked-button type="button" [disabled]="!this.printer" (click)="printInventory()">
      <fa-icon [icon]="faPrint" class="me-2"></fa-icon>Print
    </button>
    <button mat-stroked-button class="danger-btn" type="button" (click)="removeInventory()">
      <fa-icon [icon]="faTrash" class="me-2"></fa-icon>Remove
    </button>
    <button mat-raised-button color="primary" class="move-btn full-row" type="button" (click)="moveInventory()">
      <fa-icon [icon]="faArrowRight" class="me-2"></fa-icon>Move
    </button>
  </ng-template>

</div>
